import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { useContext, useEffect, useRef, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { Button } from "primereact/button";
import { AppDB } from "../../App";
import { helper } from "../../componets/utils/helper";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import VotersService from "../../services/VotersService";
import { APP_TYPE, formatDate } from "../../config/Config";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog"; // For <ConfirmDialog /> component
import EventService, { eventService } from "../../services/EventService";
import { Dropdown } from "primereact/dropdown";
import { UserDelimitation } from "../users/UserDelimitation";
import { delimitationService } from "../../services/DelimitationService";
import { InputTextarea } from "primereact/inputtextarea";
import LocalDelimitation from "../../componets/LocalDelimitation";
import LocalDelimitationNational from "../../componets/LocalDelimitationNational";
import { candidateService } from "../../services/CandidateService";
import { PrintOut } from "../reports/PrintOut";
import ScreenLoader from "../../componets/ScreenLoader";
import { reportService } from "../../services/ReportService";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import PoliticalProportionalSorting from "./PoliticalProportionalSorting";
import GenericFileCapture from "../../componets/GenericFileCapture";
import GenericDocumentTableRowHeader from "../../componets/GenericDocumentTableRowHeader";
import { lookupsService } from "../../services/LookupsService";
import GenericUploadFileTable from "../../componets/GenericUploadFileTable";
import MultiFilterSearch from "../../componets/MultiFilterSearch";

export default function ({ header = null, showAddDialog, setShowAddDialog, delimitation, setDelimitation }) {
    var { selectedParty, isOnlyView } = useContext(PoliticalPartyDBContext);
    var political = new PoliticalPartyService();
    var [proportionalMemberList, setProportionalMemberList] = useState([]);
    var [eventGroup, setEventGroup] = useState([]);
    var [event, setEvent] = useState([]);
    var [eventsMapping, setEventsMapping] = useState([]);
    var [loading, setLoading] = useState(false);
    var [refresh, setRefresh] = useState(false);
    var [isNational, setIsNational] = useState(false);
    var [votingStation, setVotingStation] = useState([]);

    var { toast } = useContext(AppDB);
    const [showuploadDocs, setshowuploadDocs] = useState(false);
    var [candidateDocuments, setCandidateDocuments] = useState([]);

    const [documentType, setdocumentType] = useState([]);

    async function GetDocumentTypes() {
        lookupsService.getDocumentTypes({
            DocumentCategoryID: 2
        }).then((res) => {
            // setisLoading(false);
            setdocumentType(res)
        }).catch((err) => {
            console.log(err);
            // setisLoading(false);
        });

    }
    var political = new PoliticalPartyService();
    var voter = new VotersService();
    var eventServices = new EventService();
    const inputFileRef = useRef(null);

    useEffect(() => {
        if (!showAddDialog?.show) {
            setCandidateDocuments([])
        }
    }, [showAddDialog])
    useEffect(() => {
        GetDocumentTypes();
        //get event groups
        eventService
            .getAllEvents({
                PageIndex: 1,
                PageSize: 100000,
                IsPoliticalPaty: true,
                ActiveOnly: true,
                NationalOnly: false
            })
            .then((res) => {
                setEventsMapping(res);
                setLoading(false);
            });
    }, [selectedParty, refresh]);


    const [fetchReportLoader, setfetchReportLoader] = useState(false)

    useEffect(() => {

        if (showAddDialog.show != true) {


            if (!["", undefined, null].includes(showAddDialog?.event?.eventID)) {
                setLoading(true);
                political
                    .getAllPolitical_proportional_candidates(selectedParty.politicalPartyID, showAddDialog.event?.eventID)
                    .then((res) => {
                        setProportionalMemberList(res.candidates);
                        setLoading(false);
                    });
            }

        }

    }, [selectedParty, refresh, delimitation, showAddDialog]);


    useEffect(() => {
        //get event groups
        setLoading(true);
        eventServices.getAllGroups().then((groups) => {
            setEventGroup(groups);
            setLoading(false);
            // setShowAddDialog({...showAddDialog,event:res})
        });
    }, [])



    useEffect(() => {
        if (showAddDialog.eventGroupID !== null) {
            setLoading(true);
            eventServices
                .getAllEvents({
                    EventGroupID: showAddDialog.eventGroupID,
                    PageIndex: 1,
                    PageSize: 100000,
                    IsPoliticalPaty: true,
                    ActiveOnly: true,
                    NationalOnly: false
                })
                .then((_event) => {
                    //get active event groups
                    setEvent(_event);
                    setLoading(false);
                });
        }
    }, [showAddDialog.eventGroupID]);

    function searchVoterByIDNumber() {
        setLoading(true);
        voter.getByIDNumber(showAddDialog.idNumber).then((res) => {
            console.log(res);
            var status = `${res}`;

            if (res?.eligibleStatus === "N") {
                setLoading(false);
                toast.show({
                    severity: "error",
                    detail: "Elector not eligible",
                    life: 2500
                });
                setShowAddDialog({
                    ...showAddDialog,
                    village: null,
                    voterRecord: null
                });
                return
            }
            if (status.trim().length === 0) {
                setLoading(false);
                toast.show({
                    severity: "error",
                    detail: "Elector not Found",
                    life: 2500
                });
                setShowAddDialog({
                    ...showAddDialog,
                    village: null,
                    voterRecord: null
                });
            } else {
                delimitationService.getRegistrationCentresByPollingDivision(res?.village?.pollingDivisionID).then((delim) => {
                    setLoading(false);
                    setVotingStation(delim);

                    var contactNumber = "";

                    res?.contactDetails.forEach((contact) => {
                        if (contact?.contactType?.name === "Cellphone") {
                            contactNumber = `${contact.countryCode.code}${contact.contactDetail}`;
                            return;
                        }
                    });

                    setShowAddDialog({
                        ...showAddDialog,
                        village: res?.village,
                        voterRecord: {
                            contactNumber: contactNumber,
                            firstname: res.firstname,
                            surname: res.surname,
                            dateOfBirth: res.dateOfBirth,
                            gender: res.gender,
                            voterID: res.voterID
                        }
                    });
                });
            }
        });
    }
    function searchVoterByFilter(idNumber) {
        setLoading(true);
        voter.getByIDNumber(idNumber).then((res) => {
            console.log(res);
            var status = `${res}`;

            if (res?.eligibleStatus === "N") {
                setLoading(false);
                toast.show({
                    severity: "error",
                    detail: "Elector not eligible",
                    life: 2500
                });
                setShowAddDialog({
                    ...showAddDialog,
                    village: null,
                    voterRecord: null
                });
                return
            }
            if (status.trim().length === 0) {
                setLoading(false);
                toast.show({
                    severity: "error",
                    detail: "Elector not Found",
                    life: 2500
                });
                setShowAddDialog({
                    ...showAddDialog,
                    village: null,
                    voterRecord: null
                });
            } else {
                delimitationService.getRegistrationCentresByPollingDivision(res?.village?.pollingDivisionID).then((delim) => {
                    setLoading(false);
                    setVotingStation(delim);

                    var contactNumber = "";

                    res?.contactDetails.forEach((contact) => {
                        if (contact?.contactType?.name === "Cellphone") {
                            contactNumber = `${contact.countryCode.code}${contact.contactDetail}`;
                            return;
                        }
                    });

                    setShowAddDialog({
                        ...showAddDialog,
                        village: res?.village,
                        voterRecord: {
                            contactNumber: contactNumber,
                            firstname: res.firstname,
                            surname: res.surname,
                            dateOfBirth: res.dateOfBirth,
                            gender: res.gender,
                            voterID: res.voterID
                        }
                    });
                });
            }
        });
    }

    const handle_proportional_member = async () => {
        const hasDocType21 = candidateDocuments.some(doc => doc.documentTypeID === 21);
        if (!showAddDialog.isEdit) {
            if (candidateDocuments.length === 0 && !hasDocType21) {
                toast.show({
                    severity: "error",
                    detail: "Nomination form is required.",
                    life: 2500
                });
                return;

            }
            if (candidateDocuments.length > 0 && !hasDocType21) {
                toast.show({
                    severity: "error",
                    detail: "Nomination form is required.",
                    life: 2500
                });
                return;

            }
             
        }
        setLoading(true);

        var callback = showAddDialog.isEdit ? political.edit_proportional_member : political.add_proportional_member


        

        callback({
            "politicalPartyID": selectedParty.politicalPartyID,
            "voterID": showAddDialog.voterRecord.voterID,
            "eventID": showAddDialog.event.eventID,
            "candidateOrder": showAddDialog.candidateOrder,
            "address": showAddDialog.address,
            "fileData": candidateDocuments[0]?.binaryData.split(",").at(1)

        }, showAddDialog?.partyProportionalCandidateID)
            .then((res) => {
                setLoading(false);
                if (res.success) {
                    setShowAddDialog({
                        ...showAddDialog,
                        show: false,
                        voterRecord: null,
                        idNumber: "",
                        village: null,
                        candidateOrder: "0"
                    });
                    setRefresh(!refresh);
                    toast.show({
                        severity: "success",
                        detail: `Member ${showAddDialog?.isEdit ? "Update" : "Added"} `,
                        life: 2500
                    });
                } else {
                    toast.show({
                        severity: "error",
                        detail: res.message,
                        life: 5500
                    });
                }
            });
    };

    const confirmDeleteProportionalMember = (e, row) => {
        confirmDialog({
            target: e.currentTarget,
            message: "Are you sure you want to proceed?",
            icon: "pi pi-exclamation-triangle",
            accept: () => {
                setLoading(true);
                political.delete_proportional_member(row).then((res) => {
                    setLoading(false);
                    if (res.success) {
                        setRefresh(!refresh);
                        toast.show({
                            severity: "success",
                            detail: "Member Removed",
                            life: 2500
                        });
                    } else {
                        toast.show({
                            severity: "error",
                            detail: res.message,
                            life: 2500
                        });
                    }
                });
            },
            reject: () => { }
        });
    };


    const handleFileUpload = async (event) => {
        alert("TO BE ADDED")
        var val = false
        if (val === false) {
            return
        }
        setLoading(true);
        const file = event.target.files[0];
        var base64File = (await helper.convertFileToBase64(file)).split(",").at(1);
        political
            .addCsvMembers({
                // politicalPartyID: selectedParty.politicalPartyID,
                // fileData: base64File,
                // title: file.name,
                // membershipPeriodID: contestationPeriodID
            })
            .then((res) => {
                setLoading(false);
                if (res.success) {
                    toast.show({
                        severity: "success",
                        detail: "Member List File Submitted",
                        life: 2500
                    });
                    setRefresh(!refresh);
                } else {
                    toast.show({
                        severity: "error",
                        detail: res.message,
                        life: 2500
                    });
                }
            });
    }
    return (
        <>
            <ScreenLoader visible={fetchReportLoader} />
            <ConfirmDialog />
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>{header !== null && <h5>{header}</h5>}</div>

            {APP_TYPE !== "PoliticalParty" && (
                <div className="card">
                    <div className="flex">
                        <div className="mr-2" style={{ display: "none" }}>
                            <Button
                                label="Upload CSV / Excel SpreadSheet"
                                loading={loading}
                                disabled={[null, undefined, ""].includes(showAddDialog.event?.eventID)}
                                onClick={() => {
                                    inputFileRef.current.value = null; // Clear the input value
                                    inputFileRef.current.click();
                                }}
                                className="p-button-success mr-3"
                            />
                            <input
                                ref={inputFileRef}
                                type={"file"}
                                multiple
                                onChange={(e) => handleFileUpload(e)}
                                style={{ display: "none" }}
                                accept=".csv,.xlsx"
                            ></input>
                        </div>
                        <div>
                            <Button
                                disabled={[null, undefined, ""].includes(showAddDialog.event?.eventID)}
                                label="Add Member"
                                loading={loading}
                                onClick={() => {
                                    setShowAddDialog({
                                        ...showAddDialog,
                                        show: true,
                                        isEdit: false,
                                        address: "",
                                        voterRecord: null,
                                        candidateOrder: "0"
                                    });
                                }}
                                className="p-button-success mr-3 ml-2"
                            />

                            {APP_TYPE !== "PoliticalParty" && (
                                <>
                                    {showAddDialog?.event?.isNationalDelimitation === true && proportionalMemberList?.length > 0 && (
                                        <Button
                                            disabled={[null, undefined, ""].includes(showAddDialog.event?.eventID)}
                                            label="Sort Members"
                                            loading={loading}
                                            onClick={() => {
                                                setShowAddDialog({ ...showAddDialog, sorting: true });
                                            }}
                                            className="p-button-success mr-3 ml-2"
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <Dialog
                header={
                    <>
                        <h5 className="my-0">
                            {showAddDialog.isEdit ? "Edit" : "Add"} Member - <small>{showAddDialog?.event?.name}</small>
                        </h5>
                    </>
                }
                style={{ width: "100%", maxWidth: "1000px" }}
                onHide={() => {
                    setShowAddDialog({
                        ...showAddDialog,
                        show: false,
                        voterRecord: null,
                        idNumber: ""
                    });
                }}
                visible={showAddDialog.show}
                footer={
                    <>
                        <Button disabled={showAddDialog.voterRecord === null} loading={loading} onClick={handle_proportional_member} label="Submit" />
                        <Button
                            className="p-button-danger"
                            onClick={() =>
                                setShowAddDialog({
                                    ...showAddDialog,
                                    show: false,
                                })
                            }
                            label="Close"
                        />
                    </>
                }
            >
                {showAddDialog?.isEdit === false && (<>
                    {/* <div className="col-12 f-bold">
                        <b>Search Elector</b>
                    </div>
                    <div className=" flex my-2">
                        <InputText
                            maxLength={12}
                            style={{ width: "100%" }}
                            placeholder="National ID"
                            value={showAddDialog.idNumber}
                            onChange={(e) => {
                                setShowAddDialog({ ...showAddDialog, idNumber: e.target.value.trim().toLowerCase() });
                            }}
                        />
                   
                        <Button
                            className="ml-2"
                            loading={loading}
                            disabled={showAddDialog.idNumber.length !== 12}
                            label="Search"
                            onClick={() => {
                                searchVoterByIDNumber();
                            }}
                        />
                    </div> */}
                    <div className="col-12">
                        <MultiFilterSearch
                            label={<>Search By <span style={{ color: "red" }}>*</span></>}
                            onClear={() => {
                                setShowAddDialog({ ...showAddDialog, voterRecord: null, idNumber: "" });
                            }}
                            onChange={res => {
                                searchVoterByFilter(res.idNumber)

                                setShowAddDialog({ ...showAddDialog, idNumber: res.idNumber });

                            }} />
                    </div>
                </>)}
                {/* <hr /> */}

                {showAddDialog.voterRecord !== null && (
                    <>
                        <div className="grid">
                            <div className="col-12  md:col-6">
                                <b>First Name</b>
                                <div className=" p-inputtext p-component p-filled">{showAddDialog.voterRecord.firstname}</div>
                            </div>

                            <div className="col-12  md:col-6 ">
                                <b>Surname</b>
                                <div className=" p-inputtext p-component p-filled">{showAddDialog.voterRecord.surname}</div>
                            </div>
                            <div className="col-12  md:col-6 ">
                                <b>Gender</b>
                                <div className=" p-inputtext p-component p-filled">{showAddDialog.voterRecord.gender}</div>
                            </div>

                            {/* <div className="col-12  md:col-6 ">
                                <b>Candidate Order   <span style={{ color: "red" }}>*</span></b>
                                <InputText
                                    className="w-full"
                                    value={showAddDialog.candidateOrder}
                                    onChange={(e) => {
                                        showAddDialog.candidateOrder = parseInt(e.target.value.trim()) || 0;
                                        setShowAddDialog({ ...showAddDialog });
                                    }}
                                />
                            </div> */}

                            <div className="col-12  md:col-6 ">
                                <b>
                                    Address <span style={{ color: "red" }}>*</span>
                                </b>
                                <InputText
                                    className="w-full"
                                    value={showAddDialog.address}
                                    onChange={(e) => {
                                        showAddDialog.address = e.target.value;
                                        setShowAddDialog({ ...showAddDialog });
                                    }}
                                />
                            </div>
                            <div className="col-12">
                                <GenericFileCapture
                                    dontClearDocuments={true}
                                    refresh={refresh}
                                    setRefresh={setRefresh}
                                    requestCall={() => { }}
                                    extraAttributes={{}}
                                    documentTypesLookUp={documentType}
                                    show={showuploadDocs}
                                    setShow={setshowuploadDocs}
                                    setDocuments={setCandidateDocuments}
                                    documents={candidateDocuments}
                                />
                                <GenericUploadFileTable
                                    header={
                                        <div className="col-12 my-2">
                                            <label htmlFor="description" className="required-input-asterisk">Upload Documents</label>
                                            <br />
                                            <>
                                                <Button
                                                    label={"Upload"}
                                                    onClick={() => setshowuploadDocs(true)}
                                                    className="p-button-success"
                                                    icon={"pi pi-plus"}
                                                />
                                            </>
                                        </div>
                                    }
                                    setDocuments={setCandidateDocuments}
                                    documents={candidateDocuments}
                                />
                            </div>
                        </div>
                    </>
                )}
            </Dialog>

            <PoliticalProportionalSorting
                onRefresh={() => {
                    setRefresh(!refresh);
                }}
                key={JSON.stringify(proportionalMemberList)}
                show={showAddDialog}
                setShow={setShowAddDialog}
                list={proportionalMemberList}
            />
            <DataTable
                size="small"
                scrollable={true}
                scrollHeight="400px"
                value={proportionalMemberList}
                dataKey="id"
                loading={loading}
                rowsPerPageOptions={[5, 10, 25]}
                className="datatable-responsive"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Members"
                emptyMessage="No members found."
                responsiveLayout="scroll"
                // selection={selectedMember}
                // onSelectionChange={(e) => setSelectedMember(e.value)}
                resizableColumns
                columnResizeMode="expand"
                // filters={filters}
                filterDisplay="Name"
                globalFilterFields={["Name"]}
            >
                <Column field="registrationNumber" header="Registration Number" sortable></Column>
                <Column field="firstname" header="Name" sortable></Column>
                <Column field="surname" header="Surname" sortable></Column>
                <Column field="gender" header="Gender" sortable></Column>
                {/* <Column field="candidateOrder" header="Candidate Order" sortable></Column> */}
                {APP_TYPE !== "PoliticalParty" && (
                    <Column
                        field="actions"
                        header="Actions"
                        body={(e) => (
                            <>
                                <Button
                                    disabled={isOnlyView}
                                    onClick={() =>
                                        setShowAddDialog({
                                            ...showAddDialog,
                                            isEdit: true,
                                            show: true,
                                            voterRecord: { ...e },
                                            candidateOrder: e.candidateOrder,
                                            address: e.address,
                                            partyProportionalCandidateID: e.partyProportionalCandidateID
                                        })
                                    }
                                    style={{ textAlign: "center", width: "30px", height: "30px" }}
                                    icon={"pi pi-pencil"}
                                    className=" p-button-rounded mr-2"
                                    tooltip="Click to edit"
                                />
                                <Button
                                    disabled={isOnlyView}
                                    onClick={(ee) => confirmDeleteProportionalMember(ee, e)}
                                    style={{ textAlign: "center", width: "30px", height: "30px" }}
                                    icon={"pi pi-trash"}
                                    className="p-button-danger p-button-rounded mr-2"
                                    tooltip="Click to delete"
                                />
                            </>
                        )}
                    ></Column>
                )}
            </DataTable>
        </>
    );
}
